import Select, { MultiValue } from 'react-select'
import { useFormContext } from 'react-hook-form'
import { FilterFormData } from './FilterReports'
import { useEffect, useState } from 'react'
import { OptionType } from '@/app/utils/optionSelectType'
import { FilterSelectStyle } from '@/view/components/BasicFilter/FilterSelectStyle'
import { optionsTypeSelect } from '@/app/utils/statusCommission'

export default function CommissionType() {
  const {
    setValue,
    formState: { errors },
    getValues,
  } = useFormContext<FilterFormData>()
  const [opt, setOpt] = useState<MultiValue<OptionType>>([])

  const fieldValue = getValues('type')
  useEffect(() => {
    if (!fieldValue) setOpt([])
    else
      setOpt(
        optionsTypeSelect.filter(({ value }) => fieldValue?.includes(value)) ||
          [],
      )
  }, [fieldValue])

  const { DropdownIndicator, customStyles } = FilterSelectStyle({
    isMulti: true,
  })

  return (
    <div className="space-y-2">
      <h3 className="font-medium text-black04">Tipo</h3>
      <Select
        options={optionsTypeSelect}
        isMulti
        onChange={(d) => {
          const values = d?.map(({ value }) => value) ?? undefined
          setValue('type', values as unknown as string)
          setOpt(d)
        }}
        value={opt}
        placeholder="Selecione o(s) status"
        styles={customStyles}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator,
        }}
      />
      {errors.type?.message}
    </div>
  )
}
